import { Box, Typography, Paper, Divider, Button } from '@mui/material';
import { Send as SendIcon } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import '../../theme/newPost.css';

interface ReviewStepProps {
  title: string;
  description: string;
  existingImageUrls: string[];
  newImages: File[];
  isEditMode: boolean;
  isSubmitting: boolean;
  onSubmit: () => void;
}

const ReviewStep: React.FC<ReviewStepProps> = ({
  title,
  description,
  existingImageUrls,
  newImages,
  isEditMode,
  isSubmitting,
  onSubmit
}) => {
  const { t } = useTranslation();
  const totalImages = existingImageUrls.length + newImages.length;
  const isValid = title.trim() && description.trim();

  return (
    <Box className="new-post-step-content">
      <Paper className="new-post-review-paper">
        <Typography variant="h6" className="new-post-review-title">
          {title}
        </Typography>
        
        <Divider sx={{ my: 2 }} />
        
        <Typography variant="body1" className="new-post-review-description">
          {description}
        </Typography>
        
        {totalImages > 0 && (
          <>
            <Divider sx={{ my: 2 }} />
            
            <Typography variant="body2" sx={{ fontWeight: 500, mb: 1, color: 'text.secondary' }}>
              {t('new_post.images')} ({totalImages})
            </Typography>
            
            <div className="new-post-review-images">
              {existingImageUrls.map((url, index) => (
                <div
                  key={`review-existing-${index}`}
                  className="new-post-review-image"
                >
                  <img
                    src={url}
                    alt={t('new_post.image_preview', { index: index + 1 })}
                  />
                </div>
              ))}
              
              {newImages.map((file, index) => (
                <div
                  key={`review-new-${index}`}
                  className="new-post-review-image"
                >
                  <img
                    src={URL.createObjectURL(file)}
                    alt={t('new_post.image_preview', { index: existingImageUrls.length + index + 1 })}
                  />
                </div>
              ))}
            </div>
          </>
        )}
      </Paper>
      
      <Box sx={{ mt: 3, display: 'flex', justifyContent: 'center' }}>
        <Button
          variant="contained"
          onClick={onSubmit}
          disabled={!isValid || isSubmitting}
          startIcon={<SendIcon />}
          className="new-post-submit-button"
        >
          {isEditMode ? t('edit_post.save') : t('new_post.publish')}
        </Button>
      </Box>
    </Box>
  );
};

export default ReviewStep;
